import script from "./MapTv.vue?vue&type=script&setup=true&lang=js"
export * from "./MapTv.vue?vue&type=script&setup=true&lang=js"

import "./MapTv.vue?vue&type=style&index=0&id=17cb0fc9&lang=css"

const __exports__ = script;

export default __exports__